(function () {
  const TARGET_VARIANT_IDS = [
    '46904799985839', // MINELLA 80g
    '46906981843119', // MINELLA II 80g
    '46903657201839', // エミューオイル リュクス ウッディ 78g
    '46903694655663', // リノフィ バニラ 78g
    '46571618959535', // デッドシーバスソルト プレーン 410g
    '45894568181935', // ハーバプラーナ シトラスウッディ
  ];
  const SHOPPER_BAG_VARIANT_ID = 46917292130479;
  const SHOPPER_BAG_PRICE = 300;

  if (!window.location.pathname.startsWith('/products/')) return;

  function createOptionUI() {
    const wrapper = document.createElement('div');
    wrapper.id = 'shopper-bag-option';
    wrapper.style.cssText = 'margin-bottom: 12px; display: none;';
                       wrapper.innerHTML = `
      <div style="margin-bottom: 8px;">
        <p style="font-weight: bold; margin-bottom: 8px;">追加オプション</p>
        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; margin-bottom: 6px; background-color: #f5f5f5; padding: 10px; border-radius: 4px;">
          <input type="radio" name="shopper-bag" value="none" checked>
          <span style="font-size: 12px;">オプション追加しない</span>
        </label>
        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; background-color: #f5f5f5; padding: 10px; border-radius: 4px;">
          <input type="radio" name="shopper-bag" value="add">
          <span>
            ショッパーバッグを追加する（＋¥${SHOPPER_BAG_PRICE.toLocaleString()}）
            <img src="https://mwj-tokyo.com/cdn/shop/files/MWJ.jpg?v=1778829230&width=990" alt="ショッパーバッグ" style="display: block; margin-top: 6px; width: 120px; height: auto; border-radius: 4px;">
          </span>
        </label>
                <a href="https://mwj-tokyo.com/products/mwj-sp?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" id="shopper-bag-link" style="display: block; margin-top: 8px; padding: 10px; background-color: #151515; border-radius: 4px; text-align: center; text-decoration: none; color: white; font-size: 13px; transition: background-color 0.2s, color 0.2s;">オリジナルショッパーバッグの詳細はこちら</a>
      </div>
    `;



;
    const style = document.createElement('style');
    style.textContent = `
      #shopper-bag-link:hover {
        background-color: white !important;
        color: #151515 !important;
      }
    `;
    wrapper.appendChild(style);

    return wrapper;
  }

  function insertOptionUI() {
    if (document.getElementById('shopper-bag-option')) return;
    const btn = document.querySelector('button.product-form__submit');
    if (!btn) return;
    btn.parentElement.insertBefore(createOptionUI(), btn);
  }

  function getSelectedVariantId() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) return variantInput.value;
    return null;
  }

  function updateVisibility() {
    insertOptionUI();
    const wrapper = document.getElementById('shopper-bag-option');
    if (!wrapper) return;
    const variantId = getSelectedVariantId();
    wrapper.style.display = TARGET_VARIANT_IDS.includes(variantId) ? 'block' : 'none';
  }

  function interceptButton() {
    const btn = document.querySelector('button.product-form__submit');
    if (!btn || btn.dataset.shopperBagHooked) return;
    btn.dataset.shopperBagHooked = 'true';

    btn.addEventListener('click', function (e) {
      const wrapper = document.getElementById('shopper-bag-option');
      if (!wrapper || wrapper.style.display === 'none') return;

      const selected = document.querySelector('input[name="shopper-bag"]:checked');
      if (!selected || selected.value !== 'add') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const variantInput = document.querySelector('input[name="id"]');
      const quantityInput = document.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(variantInput.value), quantity: quantity },
            { id: SHOPPER_BAG_VARIANT_ID, quantity: 1 }
          ]
        })
      })
        .then(res => res.json())
        .then(data => {
          console.log('カート追加成功:', data);
          window.location.href = '/cart';
        })
        .catch(err => {
          console.error('カート追加エラー:', err);
        });
    }, true);
  }

  function init() {
    updateVisibility();
    interceptButton();

    let lastVariant = getSelectedVariantId();
    setInterval(() => {
      const current = getSelectedVariantId();
      if (current !== lastVariant) {
        lastVariant = current;
        updateVisibility();
      }
    }, 300);

    document.addEventListener('variantChange', updateVisibility);
    document.addEventListener('variant:changed', updateVisibility);

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      new MutationObserver(updateVisibility).observe(variantInput, {
        attributes: true, attributeFilter: ['value']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
